import PropTypes from 'prop-types';
import React from 'react';
import {map} from 'underscore';

import {isIE} from 'common/utils';
import {Marker} from 'common/components/BetterMap';

import agencyImage from './agency.svg';
import riderImage from './favorite.svg';

const agencyIcon = {
  anchor: {x: 22, y: 22},
  size: {width: 44, height: 44},
  url: agencyImage,
};

const riderIcon = {
  anchor: {x: 22, y: 22},
  size: {width: 44, height: 44},
  url: riderImage,
};

export const AddressMarker = ({address, onClick}) => (
  <Marker
    animated={isIE()}
    icon={address.type === 'rider' ? riderIcon : agencyIcon}
    onClick={onClick && (() => onClick(address))}
    position={address.position}
  />
);

AddressMarker.propTypes = {
  address: PropTypes.shape({
    position: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }).isRequired,
    type: PropTypes.oneOf(['agency', 'rider']).isRequired,
  }).isRequired,
  onClick: PropTypes.func,
};

const AddressMarkers = ({addresses, onClick}) => {
  const markers = map(addresses, address => (
    <AddressMarker
      key={`${address.type}-${address.addressId}`}
      address={address}
      onClick={onClick}
    />
  ));
  return <div>{markers}</div>;
};

AddressMarkers.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func,
};

export default AddressMarkers;



// WEBPACK FOOTER //
// ./src/common/components/AddressMarkers/AddressMarkers.js